import axios from "axios";
import React, { useCallback, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { endpoints } from "../../trendrating/api/account/endpoints";

type Props = {
  navigateToSuccess: () => void;
};

export default function SubscribeRequest({ navigateToSuccess }: Props) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [mailSent, setMailSent] = useState(false);

  const onNameChange = useCallback((e) => {
    setName(e.target.value);
  }, []);
  const emailChangeHandle = useCallback((e) => {
    setEmail(e.target.value);
  }, []);

  const onPhoneChange = useCallback((e) => {
    setPhone(e.target.value);
  }, []);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const obj = {
        name: name,
        phone: phone,
        email: email,
      };
      const response = await axios.post(endpoints.users.subscribeRequest, obj, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          ts: new Date().getTime(),
        },
        //   withCredentials: true,
      });
      if (response.status === 200) {
        setMailSent(true);
      }
    },
    [email, name, phone],
  );

  return mailSent ? (
    <div className="success-message-wrapper">
      <i className="bi bi-check-circle-fill success-message-wrapper__icon"></i>
      <div className="success-message-wrapper__message">
        <h3>Thank you, you will be contacted shortly</h3>
      </div>
    </div>
  ) : (
    <Container fluid>
      <Row>
        <Col sm={12}>
          <p>
            Are you ready to profit from our systematic strategies and increase
            your investment returns? Subscribe to our service with competitive
            terms. The cost is a flat, fixed fee, independent of the amount of
            assets invested or the profits generated.
          </p>
          <p>
            We offer flexible terms to make it easy to get started and evaluate
            the service:
          </p>
          <ul>
            <li>
              <strong>First month:</strong> Complimentary.
            </li>
            <li>
              <strong>Second month:</strong> USD 2,000 (33% discounted fee),
              payable only if you decide to continue. If not, your access simply
              ends with no payment due.
            </li>
            <li>
              <strong>Third month onward:</strong> USD 3,000 per month, payable
              at the end of each month, if you decide to continue.
            </li>
          </ul>
          <p>
            You may discontinue the service at any time. Pay only if you are
            satisfied. No signed agreement is required.
            The service provides continuously updated stock selections and
            portfolio rebalancing actions, enabling you to independently
            replicate our model portfolios and assess their performance in
            detail.
          </p>
          <p>
            <strong>How to evaluate the service:</strong> Select the model
            portfolio that best matches your investment preferences and begin by
            tracking it with paper money or allocating a modest amount for a
            live replication. Compare its performance over time against indices
            and actively managed funds, and if you are satisfied with the
            results, increase your allocation at no additional cost.
          </p>
          <p>
            <strong>Risk Disclosure:</strong> Investing involves risk, including
            the possible loss of principal. Past performance is not indicative
            of future results, and there is no guarantee that any strategy,
            model portfolio, or security selection will achieve its objectives
            or outperform the market. The information provided by Systematic
            Gains is for informational purposes only and does not constitute
            investment advice or a recommendation to buy or sell any security.
            Subscribers remain solely responsible for their investment
            decisions.
          </p>
          <p>
            Please provide your details below, and we will contact you within 24
            hours with your access credentials.
          </p>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <form onSubmit={handleSubmit} className="mt-3 mb-3">
            <Row className="g-3">
              <Col sm={4}>
                <label className="text-light input-label" htmlFor="name">
                  Name
                </label>
                <input
                  value={name}
                  onChange={onNameChange}
                  type="text"
                  className={`form-control`}
                  id="name"
                  name="name"
                  autoComplete="off"
                  placeholder=""
                  //   ref={emailInputRef}
                />
              </Col>
              <Col sm={4}>
                <label
                  className="text-light input-label"
                  htmlFor="floatingInputEmail"
                >
                  Email address
                </label>
                <input
                  value={email}
                  onChange={emailChangeHandle}
                  type="email"
                  className={`form-control`}
                  id="floatingInputEmail"
                  name="email"
                  autoComplete="off"
                  placeholder=""
                  //   ref={emailInputRef}
                />
                {/* {checkValidation ? (
                  validInputs.email.isValid ? null : (
                    <div className="validation-error-message">
                      <p>{validInputs.email.message}</p>
                    </div>
                  )
                ) : null} */}
              </Col>
              <Col sm={4}>
                <label
                  className="text-light input-label"
                  htmlFor="floatingPassword"
                >
                  Phone number
                </label>
                <input
                  value={phone}
                  onChange={onPhoneChange}
                  className={`form-control`}
                  id="floatingPassword"
                  name="phone"
                  type="text"
                  autoComplete="off"
                  placeholder=""
                />
                {/* {checkValidation ? (
                  validInputs.password.isValid ? null : (
                    <div className="validation-error-message">
                      <p>{validInputs.password.message}</p>
                    </div>
                  )
                ) : null} */}
              </Col>
            </Row>
            <Row>
              <Col sm={2}>
                <p className="text-light input-label invisible">Button</p>
                <button
                  className="w-100 btn btn btn-outline-light"
                  type="submit"
                >
                  Contact me
                </button>
              </Col>
            </Row>
          </form>
        </Col>
      </Row>
    </Container>
  );
}
